import { render, staticRenderFns } from "./TotalsAndDelivery.vue?vue&type=template&id=1efacb55&scoped=true&"
import script from "./TotalsAndDelivery.vue?vue&type=script&lang=js&"
export * from "./TotalsAndDelivery.vue?vue&type=script&lang=js&"
import style0 from "./TotalsAndDelivery.vue?vue&type=style&index=0&id=1efacb55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efacb55",
  null
  
)

export default component.exports